const config = (state) => state.app.config;
const palette = (state) => state.app.config.palette;
const isLoading = (state) => state.app.isLoading;
const isLogged = (state) => state.app.isLogged;
const loggedUser = (state) => state.app.loggedUser;
const loginType = (state) => state.app.loginType;

export { config, palette, isLoading, isLogged, loggedUser, loginType };
